/*!
 * name: funcity
 * version: 1.5.0
 * description: A functional language interpreter with text processing
 * author: Kouji Matsui (@kekyo@mi.kekyo.net)
 * license: MIT
 * repository.url: https://github.com/kekyo/funcity
 * git.commit.hash: e583c1a43f3a2b29f8bbbb7b7ad0cc199b0a0fca
 */

/*!
* name: funcity
* version: 1.5.0
* description: A functional language interpreter with text processing
* author: Kouji Matsui (@kekyo@mi.kekyo.net)
* license: MIT
* repository.url: https://github.com/kekyo/funcity
* git.commit.hash: e583c1a43f3a2b29f8bbbb7b7ad0cc199b0a0fca
*/
import { C as isFunCityFunction, D as runTokenizer, E as runCodeTokenizer, O as FunCityReducerError, S as isConditionalTrue, T as outputErrors, _ as runParser, a as runDCodegen, b as emptyLocation, c as standardVariables, d as reduceNode, f as runReducer, g as parseExpressions, h as parseExpression, i as createDCodegen, l as createReducerContext, m as parseBlock, o as buildCandidateVariables, p as createParserCursor, r as createSharedDCodegenExecutor, s as createIncludeFunction, t as compileScriptCached, u as reduceExpressionNode, v as combineVariables, w as makeFunCityFunction, x as emptyRange, y as convertToString } from "./compile-cache-uzGiV-kt.js";
//#region src/scripting.ts
var resolveExecutionBackend = (backend) => backend !== null && backend !== void 0 ? backend : "source";
/**
* Simply runs a script once.
* @param script Input script text.
* @param props - Runner properties.
* @param signal - AbortSignal when available.
* @returns Result text when reducer is completed
*/
var runScriptOnce = async (script, props, signal) => {
	const { variables = buildCandidateVariables(), backend, aggressiveOptimize, logs = [], sourceId } = props;
	const executionBackend = resolveExecutionBackend(backend);
	const compiled = compileScriptCached(script, sourceId, "template", executionBackend, aggressiveOptimize);
	logs.push(...compiled.logs);
	if (compiled.logs.length >= 1) return [];
	const warningLogs = [];
	const reducerContext = createReducerContext(variables, warningLogs, executionBackend === "reducer" ? void 0 : createSharedDCodegenExecutor(executionBackend, aggressiveOptimize));
	try {
		const resultList = await compiled.program(reducerContext, signal);
		logs.push(...warningLogs);
		return resultList;
	} catch (error) {
		logs.push(...warningLogs);
		if (error instanceof FunCityReducerError) {
			logs.push(error.info);
			return [];
		}
		throw error;
	}
};
/**
* Simply runs a script once.
* @param script Input script text.
* @param props - Runner properties.
* @param signal - AbortSignal when available.
* @returns Result text when reducer is completed
*/
var runScriptOnceToText = async (script, props, signal) => {
	const { variables = buildCandidateVariables(), backend, aggressiveOptimize, logs = [], sourceId } = props;
	const executionBackend = resolveExecutionBackend(backend);
	const compiled = compileScriptCached(script, sourceId, "template", executionBackend, aggressiveOptimize);
	logs.push(...compiled.logs);
	if (compiled.logs.length >= 1) return;
	const warningLogs = [];
	const reducerContext = createReducerContext(variables, warningLogs, executionBackend === "reducer" ? void 0 : createSharedDCodegenExecutor(executionBackend, aggressiveOptimize));
	try {
		const text = await compiled.textProgram(reducerContext, signal);
		logs.push(...warningLogs);
		return text;
	} catch (error) {
		logs.push(...warningLogs);
		if (error instanceof FunCityReducerError) {
			logs.push(error.info);
			return;
		}
		throw error;
	}
};
//#endregion
//#region src/variables/object-variables.ts
/**
* Built-in object variables.
*/
var objectVariables = Object.freeze({
	Object,
	Function,
	Array,
	String,
	Number,
	BigInt,
	Boolean,
	Symbol,
	Math,
	ArrayBuffer,
	Date,
	Intl,
	JSON,
	Map,
	Set,
	Promise,
	RegExp,
	WeakMap,
	WeakSet,
	Reflect,
	Error
});
//#endregion
//#region src/variables/fetch-variables.ts
var getFetch = () => {
	const fetchFn = globalThis.fetch;
	if (!fetchFn) throw new Error("fetch is not available in this environment");
	return fetchFn;
};
var combineAbortSignal = (init, signal) => {
	return init ? {
		...init,
		signal
	} : { signal };
};
async function _fetch(input, init) {
	const _init = combineAbortSignal(init, this.abortSignal);
	return await getFetch()(input, _init);
}
async function _fetchText(input, init) {
	const _init = combineAbortSignal(init, this.abortSignal);
	return await (await getFetch()(input, _init)).text();
}
async function _fetchJson(input, init) {
	const _init = combineAbortSignal(init, this.abortSignal);
	return await (await getFetch()(input, _init)).json();
}
async function _fetchBlob(input, init) {
	const _init = combineAbortSignal(init, this.abortSignal);
	return await (await getFetch()(input, _init)).blob();
}
/**
* Built-in fetch API variables and functions.
*/
var fetchVariables = Object.freeze({
	fetch: _fetch,
	fetchText: _fetchText,
	fetchJson: _fetchJson,
	fetchBlob: _fetchBlob
});
//#endregion
export { FunCityReducerError, buildCandidateVariables, combineVariables, compileScriptCached, convertToString, createDCodegen, createIncludeFunction, createParserCursor, createReducerContext, createSharedDCodegenExecutor, emptyLocation, emptyRange, fetchVariables, isConditionalTrue, isFunCityFunction, makeFunCityFunction, objectVariables, outputErrors, parseBlock, parseExpression, parseExpressions, reduceExpressionNode, reduceNode, runCodeTokenizer, runDCodegen, runParser, runReducer, runScriptOnce, runScriptOnceToText, runTokenizer, standardVariables };

//# sourceMappingURL=index.mjs.map